const BASE_ADJUST = {
  brightness: 1,
  contrast: 1,
  saturation: 1,
  warmth: 0,
  blur: 0,
  temperature: 0,
  tint: 0,
  highlights: 0,
  shadows: 0,
  whites: 0,
  blacks: 0,
  vibrance: 0,
  invert: false,
  sharpness: 0,
  clarity: 0,
  vignette: 0,
};

export const FILTER_PRESETS = {
  none: {
    label: 'None',
    adjust: { ...BASE_ADJUST },
  },
  fresco: {
    label: 'Fresco',
    adjust: {
      ...BASE_ADJUST,
      brightness: 1.05,
      contrast: 1.15,
      saturation: 1.1,
      warmth: 12,
    },
  },
  belvedere: {
    label: 'Belvedere',
    adjust: {
      ...BASE_ADJUST,
      brightness: 1.08,
      contrast: 1.05,
      saturation: 0.95,
      warmth: 18,
    },
  },
  noir: {
    label: 'Noir',
    adjust: {
      ...BASE_ADJUST,
      brightness: 0.95,
      contrast: 1.35,
      saturation: 0.2,
      warmth: -10,
      clarity: 15,
      vignette: 18,
    },
  },
  vivid: {
    label: 'Vivid',
    adjust: {
      ...BASE_ADJUST,
      brightness: 1.12,
      contrast: 1.2,
      saturation: 1.4,
      warmth: 6,
      vibrance: 20,
    },
  },
  warm: {
    label: 'Warm',
    adjust: {
      ...BASE_ADJUST,
      brightness: 1.02,
      contrast: 1.05,
      saturation: 1.05,
      warmth: 30,
      temperature: 12,
    },
  },
  cool: {
    label: 'Cool',
    adjust: {
      ...BASE_ADJUST,
      brightness: 1.0,
      contrast: 1.05,
      saturation: 1.0,
      warmth: -25,
      temperature: -12,
    },
  },
};

const clamp = (value, min, max, fallback) => {
  if (value === undefined || value === null || Number.isNaN(Number(value))) {
    return fallback;
  }
  return Math.min(Math.max(Number(value), min), max);
};

export const normalizeAdjust = (adjust = {}) => ({
  brightness: clamp(adjust.brightness, 0, 2, 1),
  contrast: clamp(adjust.contrast, 0, 2, 1),
  saturation: clamp(adjust.saturation, 0, 2, 1),
  warmth: clamp(adjust.warmth, -100, 100, 0),
  blur: clamp(adjust.blur, 0, 20, 0),
  temperature: clamp(adjust.temperature, -100, 100, 0),
  tint: clamp(adjust.tint, -100, 100, 0),
  highlights: clamp(adjust.highlights, -100, 100, 0),
  shadows: clamp(adjust.shadows, -100, 100, 0),
  whites: clamp(adjust.whites, -100, 100, 0),
  blacks: clamp(adjust.blacks, -100, 100, 0),
  vibrance: clamp(adjust.vibrance, -100, 100, 0),
  invert: Boolean(adjust.invert),
  sharpness: clamp(adjust.sharpness, 0, 100, 0),
  clarity: clamp(adjust.clarity, -100, 100, 0),
  vignette: clamp(adjust.vignette, -100, 100, 0),
});

export const getPresetAdjustments = (preset) => {
  const entry = FILTER_PRESETS[preset] || FILTER_PRESETS.none;
  return { ...entry.adjust };
};

export const buildFilterString = (adjust = {}) => {
  const normalized = normalizeAdjust(adjust);
  const warmthNormalized = normalized.warmth / 100;
  const warmthAmount = Math.abs(warmthNormalized);
  const sepia = warmthAmount * 0.35;
  const hue = warmthNormalized * 15;
  return [
    `brightness(${normalized.brightness})`,
    `contrast(${normalized.contrast})`,
    `saturate(${normalized.saturation})`,
    sepia ? `sepia(${sepia})` : '',
    hue ? `hue-rotate(${hue}deg)` : '',
    `blur(${normalized.blur}px)`,
  ]
    .filter(Boolean)
    .join(' ');
};
